import {action, computed, observable} from "mobx";

import {DashboardSolution, IDashboardSolution} from "./entities/DashboardSolution";
import {IBundle} from "./BundleData";
import {API} from "../api";
import {IBadgeGroup} from "shared/IBadgeGroup";
import {DateTime} from "luxon";

function createDashboardSolutions(iSolutions:IDashboardSolution[]) {
  const solutions:DashboardSolution[] = [];
  for(let i=0;i<iSolutions.length;i++) {
    solutions.push(new DashboardSolution(iSolutions[i]));
  }
  return solutions;
}

class _DashboardData {

  @observable loaded = false;
  @observable active:DashboardSolution[];
  @observable annual:DashboardSolution[];
  @observable archived:DashboardSolution[];
  @observable companyBooth:IBundle;
  @observable selectedDashboardSolution:DashboardSolution|null = null;
  @observable singleSolution:{isSingleSolution:boolean;name:string;openDate:Date; solutionLogo:string; };

  badgeGroups:IBadgeGroup[] = [];

  @observable removedDashboardSolutionName = "";

  @computed get allDashboardSolutions() {
    return [...this.active, ...this.annual, ...this.archived];
  }

  // filter out the ones with no earned date??
  @computed get badgedDashboardSolutions() {

    const badgedDashboardSolutions:DashboardSolution[] = [];
    for(let i=0;i<this.allDashboardSolutions.length;i++) {
      if(this.allDashboardSolutions[i].badgeEarned) { //} && null!=this.allDashboardSolutions[i].badgeEarnedDate) {
        badgedDashboardSolutions.push(this.allDashboardSolutions[i]);
      }
    }
    //badgedDashboardSolutions.sort((a:DashboardSolution, b:DashboardSolution) => {a.})
    return badgedDashboardSolutions;
  }

  @action removeDashboardSolution = (dashboardSolution:DashboardSolution, password:string):Promise<void> => new Promise((resolve, reject) => {
    API.post(`/cmd/removeParticipation/${dashboardSolution._id}`, {password:password})
      .then(response => {
        const idx = this.active.findIndex((ds:DashboardSolution)=> ds._id===dashboardSolution._id);
        if(idx > -1) {
          this.removedDashboardSolutionName = this.active[idx].name
          this.active.splice(idx, 1);
        }
        resolve();
      })
      .catch((error) => {
        reject(error);
      })
  });


  load = () => new Promise<void>((resolve, reject) => {
    API.get('/dashboard')
      .then(response => {
        this.active = createDashboardSolutions( response.solutions.active );
        this.annual = createDashboardSolutions( response.solutions.annual );
        this.archived = createDashboardSolutions( response.solutions.archived );
        this.badgeGroups = response.badgeGroups ? response.badgeGroups : [];
        this.loaded = true;
        this.companyBooth = response.companyBooth;
        this.singleSolution = response.singleSolution;
        resolve();
      })
      .catch((reason)=>{
        reject(reason);
      });
  });

}

// Singleton
const DashboardData = new _DashboardData();
export default DashboardData;
